/**
 * Django content type IDs mapped from the django_content_type table.
 * Format: "app_label:model" → content_type_id
 */
const CONTENT_TYPE_MAP: Record<string, number> = {
  'identity:user': 8,
  'identity:entity': 9,
  'identity:historicaluser': 10,
  'identity:membership': 11,
  'identity:resetinfo': 12,
  'identity:sharedlink': 13,
  'identity:sharedlinkaccess': 14,
  'identity:venuecontactmembership': 15,
  'identity:venuegroupaccessmembership': 16,
  'identity:venueversioncontactmembership': 17,
  'identity:contactuser': 18,
  'identity:customersubscription': 75,
  'identity:venuecontact': 86,
  'identity:historicalentity': 91,
  'identity:customerpreferredvenuecontact': 92,
  'main:adminprioritytag': 19,
  'main:cuisinetype': 20,
  'main:historicaladminprioritytag': 21,
  'main:historicalcuisinetype': 22,
  'main:historicalneighborhood': 23,
  'main:historicalspace': 24,
  'main:historicalspaceversion': 25,
  'main:historicalvenue': 26,
  'main:historicalvenuegroup': 27,
  'main:historicalvenuetype': 28,
  'main:historicalvenueversion': 29,
  'main:neighborhood': 30,
  'main:space': 31,
  'main:spacecustomization': 32,
  'main:spaceversion': 33,
  'main:venue': 34,
  'main:venuecustomization': 35,
  'main:venuegroup': 36,
  'main:venuetype': 37,
  'main:venueversion': 38,
  'main:superspaceadminmodel': 39,
  'main:supervenueadminmodel': 40,
  'main:externallink': 66,
  'main:venuellmresult': 67,
  'main:venueaiadminmodel': 68,
  'main:venuetrustsignal': 74,
  'main:requestedvenues': 76,
  'main:missinginforequest': 77,
  'main:venuecampaignmembership': 78,
  'main:historicalvenuecampaign': 79,
  'main:historicalvenuecampaignmembership': 80,
  'main:venuecampaign': 81,
  'main:internalnotes': 83,
  'main:trustsignalsource': 84,
  'main:generalllmresult': 85,
  'main:venueresearchsnippet': 90,
  'main:historicalvenuesubgroup': 93,
  'main:venuesubgroup': 94,
  'file:fileupload': 41,
  'file:historicalfileupload': 42,
  'file:filepermission': 89,
  'crm:historicalnote': 43,
  'crm:note': 44,
  'crm:inquiryemail': 45,
  'crm:eventspacelist': 69,
  'crm:eventdate': 70,
  'crm:eventspacelistmembership': 71,
  'crm:eventspacelistmembershipdate': 72,
  'crm:eventspacelistmembershipnote': 73,
  'crm:userspace': 82,
  'crm:eventemail': 87,
  'crm:eventllmresult': 88,
  'crm:revelrec': 95,
  'crm:revelrecvenuereference': 96,
  'emails:missiveconversationvenuematch': 64,
  'emails:missivemessage': 65,
}

export type ContentTypeKey = keyof typeof CONTENT_TYPE_MAP

/**
 * Returns the Django content_type_id for a given "app_label:model" key.
 * Throws if the key is not found.
 */
export function getContentTypeId(model: ContentTypeKey): number {
  const id = CONTENT_TYPE_MAP[model]
  if (id === undefined) {
    throw new Error(`Unknown content type: "${model}"`)
  }
  return id
}
